import React from 'react';
import useVehicleTypes from '../components/hooks/useVehicleTypes';
import { VehicleContext, VehicleState } from './VehicleContext';

type VehicleProviderProps = {
    children: React.ReactNode;
    initialState?: VehicleState;
};

const VehicleProvider = ({
    children,
    initialState
}: VehicleProviderProps): JSX.Element => {
    const { vehicles, selectedVehicleIndex, setVehicles, setSelectedVehicle } =
        useVehicleTypes(initialState);

    return (
        <VehicleContext.Provider
            value={{
                vehicles,
                selectedVehicleIndex,
                setVehicles,
                setSelectedVehicle
            }}>
            {children}
        </VehicleContext.Provider>
    );
};

export default VehicleProvider;
